import BaseTabs from './BaseTabs';

class FacultyToursTabs extends BaseTabs {
  constructor() {
    super('faculty-tours-tabs');
  }

  static init() {
    new FacultyToursTabs();
  }
}

export default FacultyToursTabs;
